export const constitutionsList = [
  'Public Limited Company',
  'Private Limited Company',
  'Limited Liability Partnership',
  'Partnership Firm',
  'Sole Proprietorship',
  'Individual',
  'Hindu Un-divided Family',
  'Association Of Persons',
  'Body Of Individuals',
  'Government',
  'Artificial Juridical Person',
  'Local Authority',
  'Trust',
];

export const sectorsList = [
  'Automobile',
  'Automobile Components',
  'Aviation',
  'Chemical',
  'Consumer Durables',
  'Education & Training',
  'Engineering & Capital Goods',
  'Financial Services',
  'Gems & Jewellery',
  'Healthcare',
  'Infrastructure',
  'Insurance',
  'IT & ITES',
  'Manufacturing',
  'Media & Entertainment',
  'Oil & Gas',
  'Pharmaceuticals',
  'Ports',
  'Real Estate',
  'Retail',
  'Science & Technology',
  'Steel',
  'Telecommunication',
  'Textiles',
  'Tourism',
  'Hospitality',
];

export const segmentsList = ['Large Corporate', 'MSME', 'Mid Corporate', 'Small Scale'];
export const activitiesList = ['Manufacturing', 'Processing', 'Trading', 'Services'];

export default null;



// WEBPACK FOOTER //
// ./src/utils/lists.js